import { render } from "./EditMenuView.vue?vue&type=template&id=5647f896&scoped=true"
import script from "./EditMenuView.vue?vue&type=script&lang=js"
export * from "./EditMenuView.vue?vue&type=script&lang=js"

import "./EditMenuView.vue?vue&type=style&index=0&id=5647f896&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5647f896"]])

export default __exports__